import { CountUp } from 'countup.js';
// import 'waypoints/lib/noframework.waypoints.min';

class Zaanstad {
  constructor() {
    if ($('.hero-projects-map').length) {
      Zaanstad.changeProjectDetailDirection();
      Zaanstad.randomlyAnimateProjects();
    }

    Zaanstad.countUps();
  }

  /**
   * Add a class to a project if it crosses
   * a certain threshold
   */
  static changeProjectDetailDirection() {
    const projects = $('.hero-projects-map .hero-project');
    const distance = 55;

    // Percentages are used for this calculation
    projects.each((index, el) => {
      if (parseInt(el.style.left, 0) > distance) {
        $(el).addClass('flip');
      }
    });
  }

  /**
   * Randomly animates the sliding in/out of project details
   */
  static randomlyAnimateProjects() {
    const interval = 3800;
    const timeout = 3000;

    // Show description of a random project and hide it again after timeout
    setInterval((function test() {
      const projects = $('.hero-projects-map .hero-project').length;
      const rand = Math.floor(Math.random() * projects);
      const randomProject = $('.hero-projects-map .hero-project').eq(rand);
      const randomProjectDetails = $('.hero-project-details', randomProject);

      randomProjectDetails.css('transform', 'translateX(0)');

      window.setTimeout(() => {
        if (randomProject.hasClass('flip')) {
          randomProjectDetails.css('transform', 'translateX(101%)');
        } else {
          randomProjectDetails.css('transform', 'translateX(-101%)');
        }
      }, timeout);

      return test;
    }()), interval);
  }

  /**
   * Count numbers up animation
   */
  static countUps() {
    const countUpEl = $('[data-countup]');

    if (countUpEl.length) {
      countUpEl.each(function initCountUp() {
        const count = $(this).data('countup');
        const counter = new CountUp(this, count, {
          // duration: 2000, @theme_option
        });

        // Add waypoint to start counter when element is reached
        /* eslint-disable-next-line no-new */
        new window.Waypoint({
          element: this,
          offset: '85%', // @theme_option
          handler: () => {
            counter.start();
          },
        });
      });
    }
  }
}

$(() => {
  /* eslint-disable-next-line no-new */
  new Zaanstad();
});
